export default __webpack_public_path__ + "static/media/ccp-lock.691cf8e6.svg";